import { gsap } from 'gsap';
import { WbScroller } from '../../../webit_modules/wb-scroller/src';

export class WbAnimations {
  constructor() {
    const _this = this;
    this.addScroller();
    this.removeInitialLoading();
    this.init();
    document.addEventListener('_before_page_loaded', _this.init.bind(_this));
  }

  init() {
    return new Promise((resolve, reject) => {
      this.addAnims();
      resolve();
    });
  }

  addScroller() {
    this.scroller = window.WbScroller = new WbScroller();
    this.scroller.init();
  }

  wait(duration = 25) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, duration);
    });
  }

  removeInitialLoading() {
    const overlay = document.querySelector('.wb-load-overlay--initial');

    gsap.to(overlay, {
      opacity: 0,
      duration: 0.5,
      delay: 0.35,
      onComplete: () => {
        overlay._remove();
      },
    });
  }

  addAnims() {
    this.addBannerAnims();
  }

  addBannerAnims() {
    this.scroller.addAnim({
      element: '.wb-banner__image img',
      trigger: '.wb-banner__image img',
      timeline: [
        {
          to: { scale: 1.5 },
        },
      ],
      scrollTrigger: {
        scrub: true,
        start: 'top 50%',
      },
    });
  }
}
